import React, { useState, useEffect } from 'react';
import styles from './index.module.less';
import { downloadToolNow } from "@/utils/constants.js";

export default function(props){
  const [state, setState] = useState()

  useEffect(() => {

  }, [])

  return (
    <div className={styles.main}>
      <div className={styles["special-trip"]}>
        <span className={styles["special-trip-title"]}>立即下载踏上特效之旅</span>
        <span className={styles["special-trip-btn"]} onClick={downloadToolNow}>下载创作工具</span>
      </div>

      <div className={styles.footer}>
        <div className={styles['footer-desc']}>北京绵白糖智能科技有限公司</div>
        <div className={styles['footer-desc']}>© 北京绵白糖智能科技有限公司 版权所有.</div>
        <div className={styles['footer-desc']}>ICP备案：京ICP备2021028190号</div>
        <div className={styles['footer-desc']}>联系地址：北京市海淀区海淀北二街10号05层0503</div>
        <div className={styles['footer-desc']}>违法和不良信息举报邮箱：SenseMarsApp.Support@softsugar.com   举报电话：010-62423262</div>
      </div>
    </div>
  )
}